module.exports = __webpack_public_path__ + "img/3.48cda2f0.jpg";